export const MAX_SELECTED_MEALS = 50;
export const childServingRatio = 0.5;
